// Import model
import { OtgUser } from '../models/OtgUser';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { Organization } from '../models/Organization';

// Import dependency serializers (for complex types)
import { OrganizationSerializer } from './OrganizationSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for OtgUser - handles JSON serialization and deserialization with type validation
 */
export class OtgUserSerializer {
  /**
   * Deserializes a JSON string into a OtgUser instance
   */
  static deserialize(json: string): OtgUser {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a OtgUser instance
   */
  static fromObject(obj: any): OtgUser {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to OtgUser');
    }


    const instance: OtgUser = {
      organizationId: obj['organizationId'] as string | undefined,
      organizationIdName: obj['organizationId|Name'] as string | undefined,
      name: obj['name'] as string | undefined,
      role: obj['role'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      objectStatusIdName: obj['objectStatusId|Name'] as string | undefined,
      description: obj['description'] as string | undefined,
      id: obj['_id'] as string | undefined,
      t: obj['_t'] as string | undefined,
      email: obj['email'] as string | undefined,
      phone: obj['phone'] as string | undefined,
      timeZone: obj['timeZone'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      organization: obj['organization'] ? OrganizationSerializer.fromObject(obj['organization']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of OtgUser instances
   */
  static deserializeArray(json: string): OtgUser[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a OtgUser instance to a JSON string
   */
  static serialize(instance: OtgUser): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a OtgUser instance to a plain object
   */
  static toObject(instance: OtgUser): any {
    return {
      'organizationId': instance.organizationId,
      'organizationId|Name': instance.organizationIdName,
      'name': instance.name,
      'role': instance.role,
      'objectStatusId': instance.objectStatusId,
      'objectStatusId|Name': instance.objectStatusIdName,
      'description': instance.description,
      '_id': instance.id,
      '_t': instance.t,
      'email': instance.email,
      'phone': instance.phone,
      'timeZone': instance.timeZone,
      'isActive': instance.isActive,
      'organization': instance.organization ? OrganizationSerializer.toObject(instance.organization) : undefined,
    };
  }

  /**
   * Serializes an array of OtgUser instances to a JSON string
   */
  static serializeArray(instances: OtgUser[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
